import { setPortalKeyToken } from '@/utils/tokens';
import { isPortalHostedUrl } from '@/utils/approval/approvalAppTab';
import { IframeFlag } from '@/layout/Default';

/**
 * 앱 웹뷰로 넘길 URL 로 다듬음. 포탈이 그리는 화면만 대상 —
 * 레거시 인트라넷 URL 은 자체 인증·레이아웃을 타므로 손대지 않음.
 *
 * - embedded: GNB/탭을 서버 렌더 단계부터 숨김. 웹뷰 감지는 화면이 뜬 뒤에야 확정돼서,
 *   이게 없으면 GNB 가 한 프레임 보였다 사라짐
 * - portalApiKey: 웹뷰가 포탈 쿠키를 아직 못 받은 상태로 열릴 수 있어 쿼리로도 같이 넘김
 */
const toAppWebviewUrl = (url: string): string => {
  if (!isPortalHostedUrl(url)) return url;

  const separator = url.includes('?') ? '&' : '?';
  return setPortalKeyToken(`${url}${separator}${IframeFlag}=true`);
};

export default toAppWebviewUrl;
